const Login = require("../models/main/Login.js");
const MachineTracker = require("../models/atouchaway/MachineTracker.js");
const Refresher = require("../models/atouchaway/Refresher.js");
const UpdateRefresher = require("../models/atouchaway/UpdateRefresher.js");
const KnoxUnlock = require("../models/atouchaway/KnoxUnlock.js");
const ScreenLocker = require("../models/atouchaway/ScreenLocker.js");
const Localization = require("../models/Localization.js");
const Toast = require("../models/notifications/Toast.js");
const Save = require("../models/desktop/Save.js");
const UserMetrics = require("../models/usermetrics/UserMetrics.js");

const create = require("./create.js");

const models = [
	Localization,
	Login,
	MachineTracker,
	Refresher,
	UpdateRefresher,
	KnoxUnlock,
	ScreenLocker,
	Toast,
	Save,
	UserMetrics,
];

module.exports = create(models, "login");
